import React, { useState } from 'react';
import { 
  Box, 
  Container, 
  Tabs, 
  Tab, 
  useTheme
} from '@mui/material';
import { 
  Business, 
  Person, 
} from '@mui/icons-material';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`guide-tabpanel-${index}`}
      aria-labelledby={`guide-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ py: { xs: 2, sm: 3 } }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const GuidePage: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);
  const theme = useTheme();

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3 } }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: { xs: 2, sm: 3 } }}>
        <Tabs 
          value={tabValue} 
          onChange={handleTabChange} 
          aria-label="guide tabs"
          variant="fullWidth"
          sx={{
            '& .MuiTabs-flexContainer': {
              justifyContent: 'space-evenly'
            },
            '& .MuiTab-root': {
              textTransform: 'none',
              fontWeight: 'bold',
              fontSize: { xs: '0.9rem', sm: '1.1rem' },
              minHeight: { xs: 56, sm: 64 },
              '&:hover': {
                backgroundColor: 'rgba(0,0,0,0.04)'
              },
              flex: 1,
              maxWidth: 'none'
            },
            '& .Mui-selected': {
              color: 'primary.main'
            }
          }}
        >
          <Tab 
            icon={<Business />} 
            label="광고주 가이드" 
            iconPosition="start"
          />
          <Tab 
            icon={<Person />} 
            label="리뷰어 가이드" 
            iconPosition="start"
          />
        </Tabs>
      </Box>

      <TabPanel value={tabValue} index={0}>
        <Box>

        </Box>
      </TabPanel>

      <TabPanel value={tabValue} index={1}>
        <Box>

        </Box>
      </TabPanel>

    </Container>
  );
};

export default GuidePage; 